import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import * as echarts from 'echarts'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'

import '../public/config'

import "@/assets/js/permission"
import '@/assets/stylus/index.styl'
import '@/assets/fonts/iconfont.css'

import '@/assets/element-ui-theme/index.js'
import ElementUI from 'element-ui'
// import { Notify } from 'vant'

// Vue.config.devtools = false; 
// Vue.config.productionTip = false; 

import http from '@/assets/js/http.js'
import { post, get, put, del, getSearch } from '@/assets/js/http.js'
import VScaleScreen from 'v-scale-screen'

import axios from 'axios'


Vue.prototype.$http2 = axios

Vue.prototype.$http = http // 定义全局方法
Vue.prototype.$post = post // 定义全局post方法
Vue.prototype.$get = get // 定义全局get方法
Vue.prototype.$put = put // 定义全局put方法
Vue.prototype.$del = del // 定义全局del方法
Vue.prototype.$getSearch = getSearch // 定义全局getSearch方法

Vue.prototype.$echarts = echarts // 全局echart
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
import { mapGetters } from 'vuex'
import VueRouter from 'vue-router'

import moment from 'moment'
Vue.prototype.$moment = moment
import VueSeamlessScroll from "vue-seamless-scroll";
Vue.use(VueSeamlessScroll)
Vue.use(VScaleScreen)
Vue.use(ElementUI, { zIndex: 30000 })

// 轮播图插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import * as XLSX from 'xlsx'

import fullscreen from 'vue-fullscreen'
Vue.use(fullscreen)
// import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper)
Vue.mixin({
  data () {
    return {
      isnum: 0,
      datePicker: {
        disabledDate: time => {
          const timeYear = time.getFullYear()
          return timeYear > 2029 || timeYear < 2021
        }
      }
    }
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  created () {
  },
  mounted () {
  },
  methods: {
    isPermissions (str) {
      return this.permissions.findIndex(val => { return str === val['@NodeName'] }) >= 0
    },
    // getImgUrl(url) {//无数据图片
    //   return window.imgUrl  + url
    //   // return url ? window.imgUrl + 'ioc-prod-api' + url : require("@/assets/images/touming.png")
    // },
    uuid () {
      var temp_url = URL.createObjectURL(new Blob());
      var uuid = temp_url.toString();
      URL.revokeObjectURL(temp_url);
      return uuid.substr(uuid.lastIndexOf('/') + 1);
    },
  },
})

setInterval(() => {
  http.get('/odpsmanage/getact.osp');
}, 60000);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')